<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">{{$t('dashboard')}}</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6 mt-3 float-right">
                <b-button variant="primary" class="mb-2 float-right btn-custom" :to="'branch/create'"><font-awesome-icon icon="plus"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom" v-if="$store.getters['account/accountData'].roleDownStream[0].role === 'ADMIN'"></div>
        <div class="border-bottom mb-5" v-else></div>
        <b-row>
            <b-col md="12">
                <div v-if="$store.getters['account/accountData'].roleDownStream[0].role === 'ADMIN'">
                    <b-row class="mt-3 mb-3">
                        <b-col md="3">
                            <b-form-select v-model="tableFilter.company" :options="companyList" />
                        </b-col>
                        <!-- <b-col md="2">
                            <b-button variant="primary" class="btn-back float-left btn-custom" @click="doFilter"><font-awesome-icon icon="search"/></b-button>
                        </b-col> -->
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <paginated-table ref="dataTable" :can-delete="false" :can-show="true" :can-edit-modal="false" :can-edit="true" :can-reject="false" :can-approve="false" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns" :data-params="['company_uuid']">
        </paginated-table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        name: 'branch',
        components: {
            PaginatedTable
        },
        data () {
            return {
                dataKey: 'branch',
                apiUrl: window.AppConfig.apiUrl + 'branch?limit=25&ascending=1',
                columns: [
                    {
                        key: 'name',
                        label: this.$root.$t('name'),
                        sortable: true
                    },
                     {
                        key: 'company',
                        label: this.$root.$t('company'),
                        sortable: true
                    },
                    //  {
                    //     key: 'address',
                    //     label: this.$root.$t('address'),
                    //     sortable: false
                    // },
                    //  {
                    //     key: 'telephone',
                    //     name: 'Telephone',
                    //     sortable: true
                    // },
                     {
                        key: 'geofence',
                        label: this.$root.$t('useGeofence'),
                        sortable: false
                    },
                     {
                        key: 'statusBranch',
                        label: 'Status',
                        sortable: false
                    },
                   
                    {
                        key: 'actions',
                        label: '',
                        sortable: false
                    }
                ],
                tableFilter: {
                    company_uuid: this.$route.query.company_uuid,
                    company: null
                },
                companyList: [
                    {
                        value: null,
                        text: this.$root.$t('searchByCompany')
                    },
                ],
            }
        },
        watch: {
            'tableFilter.company' () {
                this.doFilter()
            }
        },
        mounted() {
            this.getCompany()
        },
        methods: {
            doFilter () {
                this.tableFilter.company_uuid = this.tableFilter.company
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            doSubmit () {
                this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    if (this.model.uuid !== null) {
                    let model = {}
                    Object.keys(this.model).forEach(element => {
                        if (element !== 'uuid') {
                        model[element] = this.model[element]
                        }
                    })
                    this.$http.patch(this.apiUrl + '/' + this.model.uuid, model).then(response => {
                        this.isLoading = false
                        this.$store.dispatch('notification/success', 'Branch successfully updated.')
                        this.$refs.dataTable.getDataTable()
                        this.resetData()
                        this.hideModal()
                    }).catch(error => {
                        this.isLoading = false
                        this.$store.dispatch('notification/error', error)
                    })
                    } else {
                    this.$http.post(this.apiUrl, this.model).then(response => {
                        this.isLoading = false
                        this.$store.dispatch('notification/success', 'Branch successfully added.')
                        this.hideModal()
                        this.resetData()
                        this.$refs.dataTable.getDataTable()
                    }).catch(error => {
                        this.isLoading = false
                        this.$store.dispatch('notification/error', error)
                    })
                    }
                }
                })
            },
            getCompany () {
              this.$http.get(window.AppConfig.apiUrl + 'company?limit=100').then(response => {
                response.data._embedded.company.forEach(data => {
                    this.companyList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              })
            },
            // doEdit (row) {
            //     this.type = row.type
            //     this.setData(row)
            //     this.$refs['my-modal'].show()
            // },
            // setData (row) {
            //     this.model.uuid = row.uuid
            //     this.model.name = row.name
            //     this.model.exchangeId = row.exchangeId
            // },
            // resetData () {
            //     this.model.uuid = null
            //     this.model.name = null
            //     this.model.exchangeId = null
            //     this.$validator.reset()
            // },
            // showModal(type) {
            //     this.model.name = null
            //     this.model.exchangeId = null
            //     this.model.uuid = null
            //     this.$validator.reset();
            //     this.type = type
            //     this.$refs['my-modal'].show()
            // },
            // hideModal () {
            //     this.resetData()
            //     this.$refs['my-modal'].hide()
            // }
        },
    }
</script>